module.exports = __webpack_public_path__ + "static/web-malvertising-af58a2adacfb8460a41c64e33c119ff6.gif";